import {useEffect, useState} from 'react'
import {
    DEFAULT_PASSWORD_MIN_LENGTH,
    EffectivePasswordPolicy,
    getEffectivePasswordPolicy,
} from '@/services/password-policy-services'

const FALLBACK_POLICY: EffectivePasswordPolicy = {
    minLength: DEFAULT_PASSWORD_MIN_LENGTH,
    requireDigit: false,
    requireSpecialChar: false,
    minDistinctChars: 0,
    minStrengthScore: 0,
}

// Fetches the effective password policy for the current organization so password forms can render
// the real requirements (minimum length, digit/special-character rules) instead of hard-coding
// them. Falls back to the installation defaults until the request resolves or if it fails; the
// backend re-validates on submit, so a stale fallback only affects pre-submit hints.
export function usePasswordPolicy(token: string | null | undefined): EffectivePasswordPolicy {
    const [policy, setPolicy] = useState<EffectivePasswordPolicy>(FALLBACK_POLICY)

    useEffect(() => {
        if (!token) {
            return
        }

        let active = true
        getEffectivePasswordPolicy(token)
            .then((result) => {
                if (active && result) {
                    setPolicy(result)
                }
            })
            .catch(() => {
                // Keep the fallback; the backend remains authoritative on submit.
            })

        return () => {
            active = false
        }
    }, [token])

    return policy
}
